import React from "react";
import { Star } from "lucide-react";

const FavoriteTeamStar = ({
  size = 12,
  className = "",
  title = "Features your favorite team",
}) => (
  <span
    className={`p2p-fav-star ${className}`.trim()}
    title={title}
    aria-label={title}
    role="img">
    <Star size={size} fill="currentColor" strokeWidth={0} aria-hidden />
  </span>
);

export default FavoriteTeamStar;
